import { useCurrencies, useMerchantQry, usePayApplicationFeeQry } from 'mmfintech-backend-api'
import type { ResponseCallback } from 'mmfintech-backend-api/types'
import { formatMoney, GlobalContext, tr } from 'mmfintech-commons'
import { Button, ErrorDisplay } from 'mmfintech-portal-commons'
import { useContext } from 'react'

import './ApplicationFeeInfoModal.scss'

interface Props {
  accountId: number
  onSuccess: ResponseCallback
}

function ApplicationFeeInfoModal({ accountId, onSuccess }: Props) {
  const { modalHide } = useContext(GlobalContext)

  const { merchant } = useMerchantQry()
  const { getCurrencyPrecision } = useCurrencies()

  const { payApplicationFee, payApplicationFeeError, payApplicationFeeLoading } = usePayApplicationFeeQry()

  function handleSubmit() {
    payApplicationFee(accountId, onSuccess)
  }

  return (
    <div className='application-fee-info-wrapper'>
      <div className='title'>{tr('FRONTEND.APPLICATION_FEE.INFO.TITLE', 'Application Fee Details')}</div>

      <div className='amount-wrapper'>
        <div className='amount-label'>{tr('FRONTEND.APPLICATION_FEE.INFO.AMOUNT.LABEL', 'Amount')}</div>
        <div className='amount'>
          {formatMoney(
            merchant?.accountSetupFee?.amount,
            merchant?.accountSetupFee?.currency,
            getCurrencyPrecision(merchant?.accountSetupFee?.currency)
          )}
        </div>
      </div>

      <ErrorDisplay error={payApplicationFeeError} />

      <div className='buttons-container'>
        <Button
          type='button'
          color='primary'
          text={tr('FRONTEND.APPLICATION_FEE.INFO.PAY.BUTTON', 'Pay')}
          data-test='button-pay'
          onClick={handleSubmit}
          loading={payApplicationFeeLoading}
        />
        <Button
          type='button'
          color='secondary'
          text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
          data-test='button-cancel'
          onClick={modalHide}
          disabled={payApplicationFeeLoading}
        />
      </div>
    </div>
  )
}

export default ApplicationFeeInfoModal
